// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + "algolia-search" + "." + "8883c952" + ".js";
};